import { Component, Input } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { messageSeverityEnum } from '../../enums/message-severity.enum';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'agpr-growl',
    templateUrl: './growl.component.html',
    styleUrls: ['./growl.component.scss'],
    animations: [
        trigger('animationState', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('600ms ease-out', style({ opacity: 1 })),
                animate('3000ms', style({ opacity: 1 })),
                animate('4000ms ease-in', style({ opacity: 0 }))
            ])
        ]),
        trigger('stickyAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('600ms ease-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('600ms ease-in', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class GrowlComponent {
    public readonly messageSeverityEnum = messageSeverityEnum;

    public readonly iconMap = {
        [messageSeverityEnum.success]: 'agpr-i-line-success',
        [messageSeverityEnum.warning]: 'agpr-i-line-warning',
        [messageSeverityEnum.error]: 'agpr-i-line-error'
    };

    @Input() public id: string;
    @Input() public message: ToastMessageOptions;

    public visible: boolean = true;

    dismissMessage() {
        this.visible = false;
    }
}
